import { Component, OnInit, ViewChild } from '@angular/core';
import { fadeInOutTranslate } from 'app/shared/elements/animation';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IOption } from 'ng-select';
import { HRMSService } from '../shared/hrms.service';
import { UserService } from 'app/users/shared/user.service';
import { SessionService } from 'app/sessions/session.service';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css'],
  animations: [fadeInOutTranslate]
})
export class CompanyComponent implements OnInit {
  departmentForm: FormGroup;
  designationForm: FormGroup;
  assetsForm: FormGroup;
  leavesForm: FormGroup;
  departmentHeads: Array<any> = [];
  departments:any;
  designations:any;
  assets:any;
  leaves:any;
  employeesNames:any;
  designationNames:any;
  public pageSize = 10;
  public skip = 0;
  isEdit = false;
  id:any;
  from:any;
  submitted:boolean = false;
  exists : string = null;
  public gridView: GridDataResult;
  public gridViewDesignation: GridDataResult;
  public gridViewAssets: GridDataResult;
  public gridViewLeaves: GridDataResult;
  designationsOption: Array<IOption> = [];
  @ViewChild('DepartmentsModal') departmentModal;
  @ViewChild('DesignationsModal') designationModal;
  @ViewChild('AssetsModal') assetsModal;
  @ViewChild('LeaveBalanceModal') leavesModal;
  @ViewChild('deleteModal') deleteModal;

  leaveTypes: Array<IOption> = [
    {label: 'Casual Leave', value: 'Casual Leave'},
    {label: 'Sick Leave', value: 'Sick Leave'}
  ];

  ngOnInit() {
    this.initilaizeForm();
    this.getDepartmentHeads();
    setTimeout(() => {
    this.getAllDepartments();
    }, 120);
    this.getAllDesignations();
    this.getAllAssets();
    this.getAllLeaves();
  }

  constructor(private hrmsService:HRMSService, private userService:UserService, private ss:SessionService) {
    
  }
  

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.loadItems();
  }

  private loadItems(): void {
    this.gridView = {
      data: this.departments.slice(this.skip, this.skip + this.pageSize),
      total: this.departments.length
    };

    
  }
  private loadDesignationsItems():void{
    this.gridViewDesignation = {
      data: this.designations.slice(this.skip, this.skip + this.pageSize),
      total: this.designations.length
    };
  }
  private loadAssetsItems():void{
    this.gridViewAssets = {
      data: this.assets.slice(this.skip, this.skip + this.pageSize),
      total: this.assets.length
    };
  }
  private loadLeavesItems():void{
    this.gridViewLeaves = {
      data: this.leaves.slice(this.skip, this.skip + this.pageSize),
      total: this.leaves.length
    };
  }
  private initilaizeForm()
  {
    this.departmentForm = new FormGroup({
      name: new FormControl('',Validators.required),
      value: new FormControl('',Validators.required),
      head: new FormControl('',Validators.required),
    });

    this.designationForm = new FormGroup({
      name: new FormControl('',Validators.required),
      value: new FormControl('',Validators.required),
      description: new FormControl('',Validators.required),
    });

    this.assetsForm = new FormGroup({
      name: new FormControl('',Validators.required),
      value: new FormControl('',Validators.required),
      description: new FormControl('',Validators.required),
    });

    this.leavesForm = new FormGroup({
      designation: new FormControl('',Validators.required),
      type: new FormControl('',Validators.required),
      total: new FormControl('',Validators.required),
      monthlyCredit: new FormControl('',Validators.required)
    });
  }
private getDepartmentHeads()
{
  /* var x = this.hrmsService.getDepartmentHeads();
  x.snapshotChanges().subscribe(item=>{
    this.departmentHeads = [];
    item.forEach(element =>{
        this.departmentHeads.push({label: String(element.payload.child("name").val()), value: element.key});
    });
  }); */
  var x = this.userService.getAllUser();
  x.snapshotChanges().subscribe(item=>{
    this.employeesNames = {};
    this.departmentHeads = [];
    item.forEach(element =>{
      if(element.payload.child("role").val() == "admin" || element.payload.child("role").val() == "super admin")
      {
        var y = element.payload.toJSON();
        y["$key"] = element.key;
        this.employeesNames[element.key] = element.payload.child("name").val();
        this.departmentHeads.push({label: String(element.payload.child("name").val()), value: String(element.key), employeeId: String(element.payload.child("employeeId").val())});
      }
    });
  });
}
public onSubmitDepartment()
{
  this.submitted  = true;
  this.departmentForm.get('value').setValue(this.departmentForm.value.name.toLowerCase());
  if(this.departmentForm.valid && !this.isEdit)
  {
    this.checkExistsWhileAdd(this.departmentForm.value.name.toLowerCase(),'departments');
  }
  else if(this.departmentForm.valid)
  {
    this.checkExistsWhileEdit(this.departmentForm.value.name.toLowerCase(),'departments');
  }
}
private getAllDepartments()
{
  var x = this.hrmsService.getAllDepartments();
  x.snapshotChanges().subscribe(item=>{
    this.departments = [];
    item.forEach(element =>{
        this.departments.push({
          "Department": String(element.payload.child("name").val()),
          "DepartmentHead": String(element.payload.child("head").val()),
          "DepartmentHeadName": this.employeesNames?this.employeesNames[element.payload.child("head").val()]:"",
          "NoEmployees": 5,
          "id": element.key
        });
        this.loadItems();
    });
  });
}
public editDepartment(id)
{
  this.id = id;
  var x = this.hrmsService.getDepartment(id);
  x.once("value").then((department)=>{
    this.departmentForm.get('name').setValue(department.child("name").val(),Validators.required);
    this.departmentForm.get('value').setValue(department.child("value").val(),Validators.required);
    this.departmentForm.get('head').setValue(department.child("head").val(),Validators.required);
  });
  this.departmentModal.show();
  this.isEdit = true;
}

private getAllDesignations()
{
  var x = this.hrmsService.getAllDesignations();
  x.snapshotChanges().subscribe(item=>{
    this.designations = [];
    this.designationsOption = [];
    this.designationNames = {};
    item.forEach(element =>{
        this.designations.push({
          "Designation": String(element.payload.child("name").val()),
          "Description": String(element.payload.child("description").val()),
          "NoEmployees": 5,
          "id": element.key
        });
        this.designationNames[element.key] = element.payload.child("name").val();
        this.designationsOption.push({label: String(element.payload.child("name").val()), value: String(element.key)});
        this.loadDesignationsItems();
    });
  });
}

public editDesignation(id)
{
  this.id = id;
  var x = this.hrmsService.getDesignation(id);
  x.once("value").then((designation)=>{
    this.designationForm.get('name').setValue(designation.child("name").val(),Validators.required);
    this.designationForm.get('value').setValue(designation.child("value").val(),Validators.required);
    this.designationForm.get('description').setValue(designation.child("description").val(),Validators.required);
  });
  this.designationModal.show();
  this.isEdit = true;
}
public onSubmitDesignation()
{
  this.submitted  = true;
  this.designationForm.get('value').setValue(this.designationForm.value.name.toLowerCase());
  if(this.designationForm.valid && !this.isEdit)
  {
    this.checkExistsWhileAdd(this.designationForm.value.name.toLowerCase(),'designations');
  }
  else if(this.designationForm.valid)
  {
    this.checkExistsWhileEdit(this.designationForm.value.name.toLowerCase(),'designations');
  }
}
private getAllAssets()
{
  var x = this.hrmsService.getAllAssets();
  x.snapshotChanges().subscribe(item=>{
    this.assets = [];
    item.forEach(element =>{
        this.assets.push({
          "Assets": String(element.payload.child("name").val()),
          "Description": String(element.payload.child("description").val()),
          "id": element.key
        });
        this.loadAssetsItems();
    });
  });
}
public editAssets(id)
{
  this.id = id;
  var x = this.hrmsService.getAssets(id);
  x.once("value").then((assets)=>{
    this.assetsForm.get('name').setValue(assets.child("name").val(),Validators.required);
    this.assetsForm.get('value').setValue(assets.child("value").val(),Validators.required);
    this.assetsForm.get('description').setValue(assets.child("description").val(),Validators.required);
  });
  this.assetsModal.show();
  this.isEdit = true;
}
public onSubmitAssets()
{
  this.submitted  = true;
  this.assetsForm.get('value').setValue(this.assetsForm.value.name.toLowerCase());
  if(this.assetsForm.valid && !this.isEdit)
  {
    this.checkExistsWhileAdd(this.assetsForm.value.name.toLowerCase(),'assets');
  }
  else if(this.assetsForm.valid)
  {
    this.checkExistsWhileEdit(this.assetsForm.value.name.toLowerCase(),'assets');
  }
}

private getAllLeaves()
{
  var x = this.hrmsService.getAllLeaves();
  x.snapshotChanges().subscribe(item=>{
    this.leaves = [];
    item.forEach(element =>{
        this.leaves.push({
          "Designation": String(element.payload.child("designation").val()),
          "DesignationName": this.designationNames[element.payload.child("designation").val()],
          "LeaveType": String(element.payload.child("type").val()),
          "MonthlyCredit": String(element.payload.child("monthlyCredit").val()),
          "Total": String(element.payload.child("total").val()),
          "id": element.key
        });
        this.loadLeavesItems();
    });
  });
}
public editLeaves(id)
{
  this.id = id;
  var x = this.hrmsService.getLeaves(id);
  x.once("value").then((leaves)=>{
    this.leavesForm.get('designation').setValue(leaves.child("designation").val(),Validators.required);
    this.leavesForm.get('type').setValue(leaves.child("type").val(),Validators.required);
    this.leavesForm.get('total').setValue(leaves.child("total").val(),Validators.required);
    this.leavesForm.get('monthlyCredit').setValue(leaves.child("monthlyCredit").val(),Validators.required);
  });
  this.leavesModal.show();
  this.isEdit = true;
}
public onSubmitLeaves()
{
  this.submitted  = true;
  if(this.leavesForm.valid && !this.isEdit)
  {
    this.checkLeaveAlreadyAdded(this.leavesForm.value.designation);
  }
  else if(this.leavesForm.valid)
  {
    this.checkLeaveAlreadyAddedWhileUpdate(this.leavesForm.value.designation);
  }
}
checkLeaveAlreadyAdded(value)
{
  /* this.hrmsService.isleaveAdded(value).once("value").then((data)=>{
    if(data.numChildren()>0)
    {
      console.log("exists");
    }
    else
    {
      console.log("doesnt exists");
      this.hrmsService.addLeaves(this.leavesForm.value).then(()=>{
        this.submitted  = false;
        this.leavesForm.reset();
        this.leavesModal.hide();
      });
    }
  }); */
  var keepGoing = true;
  this.leaves.forEach(data=>{
    console.log("data",data,data.Designation,this.leavesForm.value.designation , data.LeaveType, this.leavesForm.value.type);
    
    if(keepGoing && data.Designation == this.leavesForm.value.designation && data.LeaveType == this.leavesForm.value.type)
    {
      console.log("exists",data,data.Designation);
      keepGoing = false;
    }
  });
  if(keepGoing)
  {
    console.log("doesnt exists");
      this.hrmsService.addLeaves(this.leavesForm.value).then(()=>{
        this.submitted  = false;
        this.leavesForm.reset();
        this.leavesModal.hide();
        this.exists = null;
      });
  }
  else
  {
    this.exists = "This leave is already present";
    console.log("exists");
  }
}
checkLeaveAlreadyAddedWhileUpdate(value)
{
  /* this.hrmsService.isleaveAdded(value).once("value").then((data)=>{
    if(data.numChildren()>0)
    {
      console.log("exists");
      data.forEach(d=>{
        if(d.key == value)
        {
          console.log("edit");
          this.hrmsService.updateLeaves(this.leavesForm.value, this.id).then(()=>{
            this.submitted  = false;
            this.leavesForm.reset();
            this.leavesModal.hide();
            this.isEdit = false;
            this.id = null;
          });
        }
      });
    }
    else
    {
      console.log("doesnt exists");
      this.hrmsService.updateLeaves(this.leavesForm.value, this.id).then(()=>{
        this.submitted  = false;
        this.leavesForm.reset();
        this.leavesModal.hide();
        this.isEdit = false;
        this.id = null;
      });
    }
  }); */
  var keepGoing = true;
  var key;
  this.leaves.forEach(data=>{
    console.log("data",data,data.Designation,this.leavesForm.value.designation , data.LeaveType, this.leavesForm.value.type);
    
    if(keepGoing && data.Designation == this.leavesForm.value.designation && data.LeaveType == this.leavesForm.value.type)
    {
      console.log("exists",data,data.Designation);
      keepGoing = false;
      key = data.id;
    }
  });
  if(keepGoing)
  {
      console.log("doesnt exists");
      this.hrmsService.updateLeaves(this.leavesForm.value, this.id).then(()=>{
      this.submitted  = false;
      this.leavesForm.reset();
      this.leavesModal.hide();
      this.isEdit = false;
      this.id = null;
      this.exists = null;
      });
  }
  else
  {
    console.log("exists",key,this.id);
    if(key == this.id)
    {
      this.hrmsService.updateLeaves(this.leavesForm.value, this.id).then(()=>{
        this.submitted  = false;
        this.leavesForm.reset();
        this.leavesModal.hide();
        this.isEdit = false;
        this.id = null;
        this.exists = null;
      });
    }
    else
    {
      this.exists = "This leave is already present";
    }
  }
}
public openDeleteModal(id,from):void{
  this.id = id;
  this.from = from;
  this.exists  = null;
  this.deleteModal.show();
}
public delete():void{
  console.log("from",this.from,this.id);
  switch(this.from)
  {
    case 'department':
    this.hrmsService.checkExistsInEmployee(this.from,this.id).once("value").then((data)=>{
      if(data.numChildren()>0)
      {
        console.log("exists");
        this.exists  = "Department has "+data.numChildren()+" associations";
      }
      else
      {
        this.hrmsService.deleteDepartment(this.id).then(()=>{
          this.id = null;
          this.from = null;
          this.deleteModal.hide();
          this.loadItems();
        });
      }
    });
    break;
    case 'designation':
    this.hrmsService.checkExistsInEmployee(this.from,this.id).once("value").then((data)=>{
      if(data.numChildren()>0)
      {
        console.log("exists");
        this.exists  = "Designation has "+data.numChildren()+" associations";
      }
      else
      {
      this.hrmsService.deleteDesignation(this.id).then(()=>{
        this.id = null;
        this.from = null;
        this.deleteModal.hide();
        this.loadDesignationsItems();
      });
    }
  });
    break;
    case 'assets':
    this.hrmsService.checkExistsInEmployeeAssets(this.id).once("value").then((data)=>{
      if(data.numChildren()>0)
      {
        console.log("exists");
        this.exists  = "Assets has "+data.numChildren()+" associations";
      }
      else
      {
      this.hrmsService.deleteAssets(this.id).then(()=>{
        this.id = null;
        this.from = null;
        this.deleteModal.hide();
        this.loadAssetsItems();
      });
  }
  });
    break;
    case 'leaves':
    this.hrmsService.getLeaveType(this.id).once("value").then((data)=>{
      this.hrmsService.checkExistsInEmployeeLeaves(data.child("type").val()).once("value").then((data)=>{
        if(data.numChildren()>0)
        {
          console.log("exists");
          this.exists  = "Leave has "+data.numChildren()+" associations";
        }
        else
        {
      this.hrmsService.deleteLeaves(this.id).then(()=>{
        this.id = null;
        this.from = null;
        this.deleteModal.hide();
        this.loadLeavesItems();
      });
    }
  });
    });
    break;
  }
}
closeModal(from)
{
  this.submitted = false;
  this.exists = null;
  switch(from)
  {
    case 'department':
    this.departmentForm.reset();
    this.departmentModal.hide();
    break;
    case 'designation':
    this.designationForm.reset();
    this.designationModal.hide();
    break;
    case 'assets':
    this.assetsForm.reset();
    this.assetsModal.hide();
    break;
    case 'leaves':
    this.leavesForm.reset();
    this.leavesModal.hide();
    break;
  }
}
checkExistsWhileAdd(name,from)
{
  this.hrmsService.find(name,from).once("value").then((data)=>{
    if(data.numChildren()> 0)
    {
      console.log("exists",data.val());
      this.showMessage(from,name);
    }
      else
      {
        console.log("doesnt exists");
        switch(from)
        {
          case 'departments':
          this.addDepartment();
          break;
          case 'designations':
          this.addDesignation();
          break;
          case 'assets':
          this.addAssets();
          break;
        }
      }
    });
}
checkExistsWhileEdit(name,from)
{
  this.hrmsService.find(name,from).once("value").then((data)=>{
    console.log("data",data.val());
    if(data.numChildren() > 0)
    {
      console.log("exists",data.val());
      data.forEach(d=>{
        if(d.key == this.id)
        {
          console.log("edit",data.val());
          this.update(from);
        }
        else
        {
          this.showMessage(from,name);
        }
      });
      }
      else
      {
        console.log("doesnt exists",data.val());
        this.update(from);
      }
    });
}
update(from)
{
  this.exists = null;
  switch(from)
    {
      case 'departments':
      this.updateDepartment();
      break;
      case 'designations':
      this.updateDesignation();
      break;
      case 'assets':
      this.updateAssests();
      break;
    }
}
addDepartment()
{
  this.hrmsService.addDepartment(this.departmentForm.value).then(()=>{
    this.submitted  = false;
    this.departmentForm.reset();
    this.departmentModal.hide();
    this.exists = null;
  });
}
updateDepartment()
{
  this.hrmsService.updateDepartment(this.departmentForm.value, this.id).then(()=>{
    this.submitted  = false;
    this.departmentForm.reset();
    this.departmentModal.hide();
    this.isEdit = false;
  });
}
addDesignation()
{
  this.hrmsService.addDesignation(this.designationForm.value).then(()=>{
    this.submitted  = false;
    this.designationForm.reset();
    this.designationModal.hide();
    this.exists = null;
  });
}
updateDesignation()
{
  this.hrmsService.updateDesignation(this.designationForm.value, this.id).then(()=>{
    this.submitted  = false;
    this.designationForm.reset();
    this.designationModal.hide();
    this.isEdit = false;
  });
}
addAssets()
{
  this.hrmsService.addAssets(this.assetsForm.value).then(()=>{
    this.submitted  = false;
    this.assetsForm.reset();
    this.assetsModal.hide();
    this.exists = null;
  });
}
updateAssests()
{
  this.hrmsService.updateAssets(this.assetsForm.value, this.id).then(()=>{
    this.submitted  = false;
    this.assetsForm.reset();
    this.assetsModal.hide();
    this.isEdit = false;
  });
}
showMessage(from,name)
{
  switch(from)
  {
    case 'departments':
      this.exists = name+" department is already present";
      break;
      case 'designations':
      this.exists = name+" designation is already present";
      break;
      case 'assets':
      this.exists = name+" assets is already present";
      break;
  }
}
countOccurances(array)
{
  var counts = {};
  array.forEach(function(x) { counts[x] = (counts[x] || 0)+1; });
  return counts;
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/company/company.component.ts